<template>
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="10"
      height="20"
      rx="3"
      :stroke="color"
      stroke-width="1.5"
    />
    <path
      d="M11.1426 4L12.0213 3.12132C13.1928 1.94975 15.0923 1.94975 16.2639 3.12132L19.0923 5.94975C20.2639 7.12132 20.2639 9.02082 19.0923 10.1924L11.1426 18.1421"
      :stroke="color"
      stroke-width="1.5"
    />
    <path
      d="M18 11V11C19.6569 11 21 12.3431 21 14L21 18C21 19.6569 19.6569 21 18 21L6 21"
      :stroke="color"
      stroke-width="1.5"
    />
    <circle cx="6" cy="17" r="1" :fill="color" />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  color: {
    type: String,
    default: "black",
  },
});
</script>
